module.exports = __webpack_public_path__ + "static/media/phone.77d960ba.png";